import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { List } from "lucide-react";
import { api } from "../lib/api";
import { EnvCard } from "../components/EnvCard";
import { ENV_KEYS } from "../lib/constants";

export default function Explore() {
  const { t } = useTranslation();
  const [envs, setEnvs] = useState([]);
  useEffect(() => {
    api.get("/environments").then(({ data }) => setEnvs(data)).catch(() => {});
  }, []);
  return (
    <main id="main" className="mx-auto max-w-7xl px-5 sm:px-8 pt-36 pb-24" data-testid="explore-page">
      <p className="eyebrow">{t("home.envs_eyebrow")}</p>
      <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl mt-4 max-w-3xl">{t("home.cta_explore")}</h1>
      <p className="text-base md:text-lg text-[hsl(var(--muted-foreground))] mt-5 max-w-2xl">{t("home.envs_lead")}</p>
      <div className="grid md:grid-cols-3 gap-5 mt-14">
        {ENV_KEYS.map((k) => {
          const info = envs.find((e) => e.key === k);
          return (
            <div key={k} className="space-y-3">
              <EnvCard env={k} info={info} size="lg" testId={`explore-env-${k}`} />
              {info && <p className="text-sm text-[hsl(var(--muted-foreground))] px-2">{t("env.public_count", { count: info.public_count })}</p>}
            </div>
          );
        })}
      </div>
      <Link to="/memorials" className="btn-ghost mt-12" data-testid="explore-list-link"><List size={16} /> {t("footer.list_mode")}</Link>
    </main>
  );
}
